import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import { Button } from 'react-bootstrap';
import CrossChannelActions from '../../actions/CrossChannelActions';

const JsonViewer = ({ json }) =>
<div>
  <textarea style={{ width: '100%', height: '200px' }} readOnly
    value={JSON.stringify(json, null, 2)}
  />
</div>;

export default class CrossChannelComplete extends React.Component {
  constructor(props) {
    super(props);
    // When we get rid of the exposed json, get rid of this
    this.state = { showJson: false };
    this.toggleJson = this.toggleJson.bind(this);
  }

  componentWillUnmount() {
    CrossChannelActions.reset(this.props.organizationId);
  }

  // When we get rid of the exposed json, get rid of this
  toggleJson() {
    this.setState({ showJson: !this.state.showJson });
  }

  render() {
    // Get rid of the exposed json by stripping the 'Show Submitted Settings' anchor tag
    return (
      <div className='completion-block'>
        <h2>Success!</h2>
        <p>Your cross-channel analysis report is being generated right now.
          Check the <Link to='/crosschannel'>Status</Link> page for progress updates</p>
        <LinkContainer to='/crosschannel'>
          <Button block bsStyle='primary' bsSize='large'>Go to Overview Page</Button>
        </LinkContainer>
        <a
          style={{ cursor: 'pointer', textDecoration: 'none' }}
          onClick={this.toggleJson}
        >
          Show Submitted Settings
        </a>
        { this.state.showJson && <JsonViewer json={this.props.job.parametersJson} /> }
      </div>
    );
  }
}

CrossChannelComplete.propTypes = {
  job: PropTypes.object,
  organizationId: PropTypes.number,
};
